import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  HolderOutlined,
} from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Switch } from 'antd';
import cn from 'classnames';

import type {
  AppointmentPreviewField,
  AppointmentPreviewFieldKey,
} from '@pages/Calendar/data';

import type { FC } from 'react';

interface AppointmentPreviewFieldRowProps {
  field: AppointmentPreviewField;
  label: string;
  isFirst: boolean;
  isLast: boolean;
  isToggleDisabled: boolean;
  onMove(key: AppointmentPreviewFieldKey, offset: -1 | 1): void;
  onToggle(key: AppointmentPreviewFieldKey, isVisible: boolean): void;
}

export const AppointmentPreviewFieldRow: FC<
  AppointmentPreviewFieldRowProps
> = ({ field, label, isFirst, isLast, isToggleDisabled, onMove, onToggle }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.key });

  return (
    <li
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={cn('AppointmentPreviewFieldRow', {
        'AppointmentPreviewFieldRow--dragging': isDragging,
        'AppointmentPreviewFieldRow--hidden': !field.isVisible,
      })}
      data-testid={`appointment-preview-field-${field.key}`}
    >
      <button
        type="button"
        className="AppointmentPreviewFieldRow__handle"
        aria-label={`Перетащить: ${label}`}
        {...attributes}
        {...listeners}
      >
        <HolderOutlined />
      </button>

      <span className="AppointmentPreviewFieldRow__label">{label}</span>

      <Button
        type="text"
        size="small"
        icon={<ArrowUpOutlined />}
        aria-label={`Выше: ${label}`}
        disabled={isFirst}
        onClick={() => onMove(field.key, -1)}
      />
      <Button
        type="text"
        size="small"
        icon={<ArrowDownOutlined />}
        aria-label={`Ниже: ${label}`}
        disabled={isLast}
        onClick={() => onMove(field.key, 1)}
      />
      <Switch
        size="small"
        checked={field.isVisible}
        disabled={isToggleDisabled}
        aria-label={`Показывать: ${label}`}
        onChange={(checked) => onToggle(field.key, checked)}
      />
    </li>
  );
};
